
import { ISketch, Sketch } from '@auvious/sketch';
import { AuviousCommon } from "@auvious/common";
import { IEndpoint } from '@auvious/rtc';
import { Log } from './log.service';
import { NotificationService } from './notification.service';
import { ErrorCode } from '../models';

class SketchServiceCtrl {

    private sketchInstance: ISketch;

    public async connect(
        common?: AuviousCommon,
        participant?: IEndpoint,
        canvas?: HTMLCanvasElement,
        sketchId?: string
    ): Promise<ISketch> {
        try {
            this.sketchInstance = Sketch.create(canvas, common);
            await this.sketchInstance.connect({
                sketchId,
                userId: participant.username,
                userEndpointId: participant.endpoint
            });
            this.sketchInstance.events.on('error', this.onError);
            return this.sketchInstance;
        } catch (ex) {
            Log.error(ex);
            throw ex;
        }
    }

    public clear() {
        this.sketchInstance?.events.off('error', this.onError);
        this.sketchInstance = null;
    }

    onError = (err) => {
        Log.error(err);
        NotificationService.error('Sketch error', { body: err.message || err, errorCode: ErrorCode.SKETCH_API_ERROR });
    }

}

export const SketchService = new SketchServiceCtrl();